import { useEffect, useState } from "react";
import { resolveLocalImageUrl } from "../../data/local-assets";

interface Props {
  src?: string | null;
  alt?: string;
  className?: string;
  fallbackLabel?: string;
}

export function GameImage({
  src,
  alt = "",
  className = "challenge-image",
  fallbackLabel = "?",
}: Props) {
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    setFailed(!src);
    setRetry(0);
  }, [src]);

  if (!src || failed) {
    return (
      <div className={`${className} challenge-image-fallback`} aria-label={alt || "Missing picture"}>
        {fallbackLabel}
      </div>
    );
  }

  const localSrc = resolveLocalImageUrl(src) ?? src;
  const resolvedSrc = retry > 0 && localSrc.startsWith("/")
    ? `${localSrc}${localSrc.includes("?") ? "&" : "?"}retry=${retry}`
    : localSrc;

  return (
    <img
      key={`${src}:${retry}`}
      className={className}
      src={resolvedSrc}
      alt={alt}
      loading="eager"
      decoding="async"
      onError={() => {
        if (retry < 2) {
          window.setTimeout(() => setRetry((n) => n + 1), 180);
          return;
        }
        setFailed(true);
      }}
    />
  );
}
